import translate from '../../../i18n'
import { SalesCampaignStatusOptions } from '../../../pages/sales-campaigns-container/constant'
import { ISalesCampaignFilterParams } from '../../../pages/sales-campaigns-container/share-type'
import FormattedMessage from '../../intl/format-message'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Input, Select } from 'antd'
import { useEffect } from 'react'

interface ISalesCampaignFilter {
  onSearch: (value: ISalesCampaignFilterParams) => void
  formData: ISalesCampaignFilterParams | undefined
}

const SalesCampaignFilter = (props: ISalesCampaignFilter) => {
  const { onSearch, formData } = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData)
    }
  }, [formData])

  const onFinish = (values: ISalesCampaignFilterParams) => {
    onSearch(values)
  }

  return (
    <Form form={form} layout="inline" className="filter-inline-form" onFinish={onFinish}>
      <Form.Item name="name" label={`${translate('name')}`}>
        <Input placeholder="输入名称" />
      </Form.Item>
      <Form.Item name="status" label={translate('status')}>
        <Select style={{ minWidth: 130 }} allowClear options={SalesCampaignStatusOptions} />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          <FormattedMessage id="search"></FormattedMessage>
        </Button>
      </Form.Item>
    </Form>
  )
}

export default SalesCampaignFilter
